<script setup lang="ts">
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import TripTypeBanner from './TripTypeBanner.vue';
import TripTypeSelectorPanel from './TripTypeSelectorPanel.vue';
import type { TripType } from './TripTypeSelectorPanel.model';

interface TripTypeSelectorViewProps {
  destinationName: string;
  departureAirport: string;
  departurePort: string;
  carStartPosition: string;
}
const props = defineProps<TripTypeSelectorViewProps>();

interface TripTypeSelectorViewEmits {
  (event: 'confirm', tripType: TripType): void;
  (event: 'edit', tripType: TripType): void;
  (event: 'select', tripType: TripType): void;
}
const emit = defineEmits<TripTypeSelectorViewEmits>();

const browserStore = useBrowserStore();
</script>

<template>
  <div class="trip-type-selector-view">
    <TripTypeBanner
      v-if="!browserStore.isSmallerThanLargeMin"
      :destination-name="props.destinationName"
    />
    <TripTypeSelectorPanel
      :departure-airport="props.departureAirport"
      :departure-port="props.departurePort"
      :car-start-position="props.carStartPosition"
      @confirm="emit('confirm', $event)"
      @edit="emit('edit', $event)"
      @select="emit('select', $event)"
    />
  </div>
</template>

<style scoped lang="scss">
.trip-type-selector-view {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: grid;
  grid-template-columns: 66.66% 33.33%;
  @include for-less-or-equal-than-medium-max {
    display: grid;
    grid-template-columns: auto;
  }
}
</style>
